import { Fragment } from 'react';

import Icon from '../../../components/UI/MDC/Icon/Icon';
import { Headline6 } from '../../../components/UI/MDC/Typography/Typography';
import Dropdown from '../../../components/UI/Input/Dropdown/Dropdown';
import StyleAuxiliary from '../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import classes from '../../../components/UI/Input/Dropdown/Dropdown.module.scss';
import * as utils from '../../../utils';

const ValidationDropdown = props => {
	const {
		entryKey,
		formDetails,
		placeholder,
		handleChange,
		onBlur,
		className,
		disabled,
	} = props;
	const showValidation = formDetails.validation.touched;
	const validationMessage = showValidation ? props.validationMessage : null;
	const validity = showValidation
		? !(props.validationMessage && props.validationMessage.length > 0) &&
		  props.valid
		: true;
	const iconStyle = validity
		? 'validation__icon--valid'
		: 'validation__icon--invalid';
	const iconShape = validity ? 'check_circle_outline' : 'block';
	return (
		<>
			<Fragment>
				<StyleAuxiliary
					classes={utils.concatenateClassNames(
						['input__drop--full-width'],
						classes
					)}
				>
					<Icon icon={iconShape} className={classes[iconStyle]} />
					<Dropdown
						entryKey={entryKey}
						formDetails={formDetails}
						placeholder={placeholder}
						handleChange={handleChange}
						onBlur={onBlur}
						className={className}
						disabled={disabled}
					/>
					<StyleAuxiliary
						classes={classes['input__validation--invalid']}
					>
						<Headline6>{validationMessage}</Headline6>
					</StyleAuxiliary>
				</StyleAuxiliary>
			</Fragment>
		</>
	);
};

export default ValidationDropdown;
